import mapboxgl from "mapbox-gl";

import { addSourcesIfNotExist } from "../../map/sources";

export const breaksSources = {
    breaksSrc: "breaks_src",
};

export const initSources = (map: mapboxgl.Map): void => {
    addSourcesIfNotExist(map, Object.values(breaksSources));
};
